// extracted by mini-css-extract-plugin
module.exports = {"Button":"x_qT s_qT s_qN g_dr g_dG g_dv g_gg","full":"x_rP g_cp g_cz","width100":"x_cp g_cp","design3Pos":"x_rQ g_cT"};